import React, { useEffect } from 'react';
import Style from '../Styles/SearchProductsStyle'
import Settings from '../../../Settings/Settings'
import Paper from '@mui/material/Paper';
import InputBase from '@mui/material/InputBase';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import Grid from '@mui/material/Grid';
import CancelIcon from '@mui/icons-material/Cancel';

export default function SearchProducts(props) {
  const classes = Style();

    const componentConstants = {
        ...props.componentConstants
    }

    const componentMethods = {
        ...props.componentMethods
    }

    let yourUrlParamsSearchQuery = ''
    if(componentConstants.urlParams && componentConstants.urlParams.query) {
      yourUrlParamsSearchQuery = componentConstants.urlParams.query
    }
    const [yourImagesQuery, setYourImagesQuery] = React.useState(yourUrlParamsSearchQuery)

    const handleKeyPress = (event) => {
        if(event.key === 'Enter'){
          event.preventDefault()
          searchProductsAction(event)
        }
    }
    const handleClearSearch = () => {
      componentMethods.changeRoute('/')
    }
    const searchProductsAction = (e) => {
          if(yourImagesQuery) {
            componentMethods.changeRoute('/search/' + yourImagesQuery)
          } else {
            componentMethods.changeRoute('/')
          }
      }

    return   <React.Fragment>
      <Grid item xs={1} lg={4} md={1}></Grid>
    <Grid item xs={10} lg={4} md={10}>
      <Paper component="form" style={classes.root}>
    <InputBase
      style={classes.input}
      placeholder={componentConstants.language.LANG_SEARCH_PRODUCTS + "..."}
      inputProps={{ 'aria-label': componentConstants.language.LANG_SEARCH_PRODUCTS + "..." }}
      value={yourImagesQuery} 
      onChange={(event)=>{ setYourImagesQuery(event.target.value)}}
      onKeyPress={handleKeyPress}
    />
    <IconButton type="button" onClick={searchProductsAction} style={classes.iconButton} aria-label="search">
      <SearchIcon />
    </IconButton>
    {
      yourImagesQuery ?
        <IconButton type="button" onClick={() => {handleClearSearch()}} style={classes.iconButton} aria-label="search">
          <CancelIcon />
        </IconButton>
      :
      null
    }
    </Paper> </Grid><Grid item xs={1} lg={4} md={1}></Grid>
    </React.Fragment>
}
